import { makeStyles } from '@material-ui/core/styles'
import {
  Theme,
  RadioGroup,
  Typography,
  Grid,
  FormControlLabel,
} from '@material-ui/core'
import { useIntl } from 'react-intl'
import { useFormikContext } from 'formik'
import {
  specificationItem,
  SemiConfigFormValues,
} from '../ProductsConfiguration'
import StyledRadio from '@src/routes/Configurators/utils/ConfiguratorCustomRadioButton'
import ValidationErrors from '@src/routes/Configurators/validations/ValidationErrors'

const useStyles = makeStyles((theme: Theme) => ({
  dropDown: {
    paddingTop: theme.spacing(4),
  },
}))
interface SpecificationRadio {
  list: specificationItem[]
  specificationName: string
  specificationValue: string | undefined
  handleChange: (f: string, v: string) => void
  showRequiredError?: boolean
  hasInfo?: boolean
}

const SpecificationRadio = ({
  list,
  specificationName,
  specificationValue,
  handleChange,
  showRequiredError = false,
  hasInfo = false,
}: SpecificationRadio) => {
  const classes = useStyles()
  const intl = useIntl()
  const formik = useFormikContext<SemiConfigFormValues>()
  const onChange = (e: React.ChangeEvent<{ value: unknown }>) => {
    handleChange(specificationName, e.target.value as string)
  }

  return (
    <Grid item xs={12} className={!hasInfo ? classes.dropDown : undefined}>
      <RadioGroup
        aria-label="specifications"
        name={specificationName}
        onChange={onChange}
        value={specificationValue}
        row
      >
        {list?.map((option) => {
          if (list.length === 1) {
            return <Typography key={option.key}>{option.value}</Typography>
          }

          return (
            <FormControlLabel
              control={<StyledRadio isConfiguratorsRedesign="true" />}
              label={<Typography>{option.value}</Typography>}
              value={option.key}
              disabled={option.enabled === false}
              key={option.key}
              checked={option.key === specificationValue}
            />
          )
        })}
      </RadioGroup>
      {showRequiredError &&
        !specificationValue &&
        formik.values.displayPageError &&
        formik.values.completedStep >= 2 && (
          <ValidationErrors
            errors={[
              intl.formatMessage({
                id: 'CONF_REQUIRED_FIELD',
                defaultMessage: 'Required Field',
              }),
            ]}
            configuratorsRedesign
          />
        )}
    </Grid>
  )
}

export default SpecificationRadio
